/**
 * Story 033 — global-default catalogue sentinel + the "are we currently
 * rendering against the global default?" predicate that drives the AC6
 * banner. The contract schemas these previously sat next to now live in
 * `@aeriosiq/types`; what stays here is the FE-only display logic.
 */
import type { DefectCatalogue } from "@aeriosiq/types";

/** Synthetic sentinel id used when the tenant has zero own catalogues. */
export const GLOBAL_DEFAULT_CATALOGUE_ID = "global-default";

/**
 * Decide whether to render the "Using global default catalogue …" banner
 * (Story 033 AC6). True iff the only item we have is the sentinel.
 */
export function isUsingGlobalDefault(
  items: readonly DefectCatalogue[] | undefined | null,
): boolean {
  if (!items) return false;
  return (
    items.length === 1 && items[0]?.catalogueId === GLOBAL_DEFAULT_CATALOGUE_ID
  );
}
